import { PATH_APP } from './paths';
import React, { lazy } from 'react';
import { Navigate } from 'react-router';

import AuthProtect from '../components/Auth/AuthProtect';
import DashboardLayout from '../layouts/AppLayout';
import { NestedRoute } from './types';

const Appointments = lazy(() => import('../views/Pages/Appointments'));
const AppointmentSlotItemList = lazy(
  () => import('../views/Pages/AppointmentSlot/SlotItemList')
);
const AddEditSlotItem = lazy(
  () => import('../views/Pages/AppointmentSlot/AddEditSlotItem')
);
const Retail3TicketList = lazy(
  () => import('../views/Pages/Retail3/TicketList')
);
const Retail3SingleTicket = lazy(
  () => import('../views/Pages/Retail3/SingleTicket')
);
const CustomerList = lazy(() => import('../views/Pages/Customer/CustomerList'));
const AddEditCustomer = lazy(
  () => import('../views/Pages/Customer/AddEditCustomer')
);
const AdvancedMDLink = lazy(
  () => import('../views/Pages/Customer/AdvancedMDLink')
);
const CustomerProfile = lazy(
  () => import('../views/Pages/Customer/CustomerProfile')
);
const StaffManagement = lazy(() => import('../views/Pages/StaffManagement'));
const TherapistList = lazy(
  () => import('../views/Pages/Therapist/TherapistList')
);
const AddEditTherapist = lazy(
  () => import('../views/Pages/Therapist/AddEditTherapist')
);
const ShiftLead = lazy(
  () => import('../views/Pages/ShiftLead')
);
const TherapistProfile = lazy(
  () => import('../views/Pages/Therapist/TherapistProfile')
);
const GiftCards = lazy(() => import('../views/Pages/GiftCards'));
const PromotionsList = lazy(() => import('../views/Pages/Promotions/List'));
const CategorizedPriceList = lazy(
  () => import('../views/Pages/CategorizedPriceList')
);
const ProductList = lazy(() => import('../views/Pages/Product/ProductList'));
const AddEditProduct = lazy(
  () => import('../views/Pages/Product/AddEditProduct')
);
const ProductAvailability = lazy(
  () => import('../views/Pages/Product/ProductAvailability')
);
const Product2List = lazy(() => import('../views/Pages/Product2'));
const CreditList = lazy(() => import('../views/Pages/Credit/CreditList'));
const StudioDashboard = lazy(() => import('../views/Pages/StudioDashboard'));
const Terminals = lazy(() => import('../views/Pages/Terminals'));
const Reports = lazy(() => import('../views/Pages/Reports/index'));

const NavigateTo404 = () => <Navigate to="/404" />;

const AppRoutes: NestedRoute = {
  guard: AuthProtect,
  path: PATH_APP.root,
  layout: DashboardLayout,
  routes: [
    // Appointments
    {
      path: PATH_APP.appointment.root,
      element: Appointments
    },
    {
      path: PATH_APP.appointment.slotItems,
      element: AppointmentSlotItemList
    },
    {
      path: PATH_APP.appointment.addSlotItem,
      element: AddEditSlotItem
    },
    {
      path: PATH_APP.appointment.editSlotItem,
      element: AddEditSlotItem
    },
    // Retail
    {
      path: PATH_APP.retail3.root,
      element: Retail3TicketList
    },
    {
      path: PATH_APP.retail3.single,
      element: Retail3SingleTicket
    },
    // Customer
    {
      path: PATH_APP.customer.root,
      element: CustomerList
    },
    {
      path: PATH_APP.customer.add,
      element: AddEditCustomer
    },
    {
      path: PATH_APP.customer.edit,
      element: AddEditCustomer
    },
    {
      path: PATH_APP.customer.amd,
      element: AdvancedMDLink
    },
    {
      path: PATH_APP.customer.profile.root,
      element: CustomerProfile
    },
    {
      path: PATH_APP.staffmgmt.root,
      element: StaffManagement
    },
    {
      path: PATH_APP.shiftLead.root,
      element: ShiftLead
    },
    {
      path: PATH_APP.therapist.root,
      element: TherapistList
    },
    {
      path: PATH_APP.therapist.add,
      element: AddEditTherapist
    },
    {
      path: PATH_APP.therapist.edit,
      element: AddEditTherapist
    },
    {
      path: PATH_APP.therapist.profile,
      element: TherapistProfile
    },
    ///Gift Card
    {
      path: PATH_APP.giftCards.root,
      element: GiftCards
    },
    // Promotions
    {
      path: PATH_APP.promotions.root,
      element: PromotionsList
    },
    // Categorized Price List
    {
      path: PATH_APP.categorized.root,
      element: CategorizedPriceList
    },
    // Product
    {
      path: PATH_APP.product.root,
      element: ProductList
    },
    {
      path: PATH_APP.product.add,
      element: AddEditProduct
    },
    {
      path: PATH_APP.product.edit,
      element: AddEditProduct
    },
    {
      path: PATH_APP.product.availability,
      element: ProductAvailability
    },
    // Product 2
    {
      path: PATH_APP.product2.root,
      element: Product2List
    },
    // Credit
    {
      path: PATH_APP.credit.root,
      element: CreditList
    },
    // Dashboard
    {
      path: PATH_APP.studiodashboard.root,
      element: StudioDashboard
    },
    {
      path: '/terminals',
      element: Terminals
    },
    {
      path: PATH_APP.reports.root,
      element: Reports
    },
    {
      path: '*',
      element: NavigateTo404
    }
  ]
};

export default AppRoutes;
